import script from "./RetiredWarningModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RetiredWarningModal.vue?vue&type=script&setup=true&lang=js"

import "./RetiredWarningModal.vue?vue&type=style&index=0&id=348dd673&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348dd673"]])

export default __exports__